import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { HcoIcon } from '@/assets/icons/HcoIcon';
import { HcpIcon } from '@/assets/icons/HcpIcon';
import { DcrType, EntityType } from '@/core/graphql/generated/types';
import { DataChangeRequest } from '@/features/DataChangeRequest/DcrModal/DataChangeRequest';
import { useBreakpoint } from '@/utils/useBreakpoint';

import { addMissingProfileMenuStyles as sx } from './AddMissingProfileMenu.styles';

export const AddMissingProfileMenu = () => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const open = !!anchorEl;
	const [width, setWidth] = useState(150);
	const isSmall = useBreakpoint('xs', 'only');
	const [isDcrOpen, setIsDcrOpen] = useState(false);
	const [selectedEntityType, setSelectedEntityType] =
		useState<EntityType | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const handleDcrOpen = () => {
		setIsLoading(true);
		setIsDcrOpen(true);
	};

	const handleDcrClose = () => {
		setIsLoading(false);
		setIsDcrOpen(false);
	};

	const handleOption = (entityType: EntityType) => {
		setSelectedEntityType(entityType);
		handleDcrOpen();
		handleClose();
	};

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
		setWidth(event.currentTarget?.offsetWidth);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			{selectedEntityType && (
				<DataChangeRequest
					entityType={selectedEntityType}
					formType={DcrType.Add}
					open={isDcrOpen}
					onClose={handleDcrClose}
					onLoaded={() => setIsLoading(false)}
				/>
			)}

			{isSmall ? (
				<Tooltip title={t('Request New Profile')}>
					<IconButton color='primary' onClick={handleClick} loading={isLoading}>
						<PersonAddIcon />
					</IconButton>
				</Tooltip>
			) : (
				<Button
					variant='contained'
					onClick={handleClick}
					endIcon={<ExpandMoreIcon />}
					loading={isLoading}
					loadingPosition='end'
				>
					{t('Request New Profile')}
				</Button>
			)}

			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				disableScrollLock
				slotProps={{
					list: {
						sx: {
							minWidth: 150,
							width
						}
					}
				}}
			>
				<MenuItem onClick={() => handleOption(EntityType.Hcp)} sx={sx.option}>
					<HcpIcon />
					{t('HCP')}
				</MenuItem>
				<MenuItem onClick={() => handleOption(EntityType.Hco)} sx={sx.option}>
					<HcoIcon />
					{t('HCO')}
				</MenuItem>
			</Menu>
		</>
	);
};
